import React, { useState } from 'react';
import LinkButton from '../../../BaseModule/Components/Button/LinkButton/LinkButton';
import SubscriptionCancellationModal from './SubscriptionCancellationModal';
import SubscriptionCancellationConfirmationModal from './SubscriptionCancellationConfirmationModal';
import SubscriptionSuccessfulCancellationModal from './SubscriptionSuccessfulCancellationModal';
import NetteApiClient from '../../../../Services/NetteApiClient';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	subscriptionId: string;
}

const SubscriptionCancellation: React.FC<Props> = ({ subscriptionId }) => {
	// @ts-ignore
	const { refreshPage } = useAppContext();
	const [isCancellationModalOpen, setIsCancellationModalOpen] = useState(false);
	const [
		isCancellationConfirmationModalOpen,
		setIsCancellationConfirmationModalOpen,
	] = useState(false);
	const [
		isSuccessfulCancellationModalOpen,
		setIsSuccessfulCancellationModalOpen,
	] = useState(false);

	const handleOnCancelSubscription = () => {
		setIsCancellationModalOpen(false);
		setIsCancellationConfirmationModalOpen(true);
	};

	const handleOnSuccessfulCancellation = () => {
		setIsCancellationConfirmationModalOpen(false);
		setIsSuccessfulCancellationModalOpen(true);
	};

	const handleCloseInformationModal = async () => {
		setIsSuccessfulCancellationModalOpen(false);
		await NetteApiClient.get(refreshPage);
	};

	return (
		<>
			{isCancellationModalOpen && (
				<SubscriptionCancellationModal
					isOpen
					onClose={() => setIsCancellationModalOpen(false)}
					onCancelSubscription={handleOnCancelSubscription}
				/>
			)}
			{isCancellationConfirmationModalOpen && (
				<SubscriptionCancellationConfirmationModal
					isOpen
					onClose={() => setIsCancellationConfirmationModalOpen(false)}
					subscriptionId={subscriptionId}
					onSuccessfulCancellation={handleOnSuccessfulCancellation}
				/>
			)}
			{isSuccessfulCancellationModalOpen && (
				<SubscriptionSuccessfulCancellationModal
					isOpen
					onClose={handleCloseInformationModal}
				/>
			)}
			<LinkButton
				text='component.subscriptionCancellation.cancelSubscription'
				theme='purple'
				onClick={() => setIsCancellationModalOpen(true)}
			/>
		</>
	);
};

export default SubscriptionCancellation;
